import { render, staticRenderFns } from "./ForgotUsername.vue?vue&type=template&id=0c2c6f3a&scoped=true&"
import script from "./ForgotUsername.vue?vue&type=script&lang=js&"
export * from "./ForgotUsername.vue?vue&type=script&lang=js&"
import style0 from "./ForgotUsername.vue?vue&type=style&index=0&id=0c2c6f3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2c6f3a",
  null
  
)

export default component.exports